import { RouteConfig } from 'vue-router';

const PatientList = () => import(/* webpackChunkName: "Idr" */  './views/patient-list/patient-list.vue');
const PatientDetail = () => import(/* webpackChunkName: "Idr" */  './views/patient-detail/patient-detail.vue');
const DataExport = () => import(/* webpackChunkName: "Idr" */  './views/data-export/data-export.vue');
const TongueList = () => import(/* webpackChunkName: "Idr" */  './views/tongue-list/tongue-list.vue');

// module
const Biaozhu = () => import(/* webpackChunkName: "Idr" */  './module/biaozhu/biaozhu.vue');
// const Biaozhu = () => import(/* webpackChunkName: "Idr" */  './module/biaozhu-new/biaozhu.vue');
const BiaozhuList = () => import(/* webpackChunkName: "Idr" */  './module/biaozhu/biaozhu-list.vue');
const BiduiList = () => import(/* webpackChunkName: "Idr" */  './module/bidui/bidui-list.vue');
const BiduiDetail = () => import(/* webpackChunkName: "Idr" */  './module/bidui/bidui-detail.vue');


const routers: RouteConfig[] = [
    {
        path: 'patient-list',
        component: PatientList,
        meta: {
            keepAlive: true
        }
    },
    {
        path: "patient-detail",
        component: PatientDetail
    },
    {
        path: "data-export",
        component: DataExport
    },
    {
        path: "tongue-list",
        component: TongueList,
        meta: {
            keepAlive: true
        }
    },
    {
        path: "tongue-biaozhu",
        component: Biaozhu
    },
    {
        path: "tongue-biaozhu-list",
        component: BiaozhuList,
        meta: {
            keepAlive: true
        }
    },
    {
        path: "tongue-bidui-list",
        component: BiduiList,
    },
    {
        path: "tongue-bidui-detail",
        component: BiduiDetail
    }
];

export default routers;
